export default {
  AccessControl: '访问控制',
  AccessRule: '访问规则',
  AccessRuleTitle: '访问控制功能对匹配规则的流量执行相关的访问策略，达到访问控制的目的。',
  AccessRuleDesc1: '预设访问规则：您可以预设访问规则，允许通过或者拒绝通过指定的流量，提高您网络的安全性。',
  AccessRuleDesc2: '流量管控规则：您可以在',
  AccessRuleDesc3: '流量记录',
  AccessRuleDesc4: '中禁用指定流量，从而同步创建管控规则。', // desc2,3,4本为一句话，因为desc3为可点击链接，所以拆分为3句
  RuleInfo: '规则信息',
  PreAccessRule: '预设访问规则',
  FlowControlRule: '流量管控规则',
  AssociatedNet: '流量默认按照访问控制规则优先级，从高到低进行匹配。若您未设置优先级或优先级相同，将默认按照创建时间早的规则优先生效。',
  SpecialNote: '特别提示：批量操作仅用于新增关联关系，访问规则原绑定的网关关系将保留，不会被修改。如有需要，可前往',
  ToManage: '下进行管理。', // SpecialNote和ToManage本为一句话，因为有可点击链接，所以拆分，原句为：特别提示：批量操作仅用于新增关联关系，访问规则原绑定的网关关系将保留，不会被修改。如有需要，可前往访问控制-已关联网关下进行管理。
  BatchDeleteRule: '批量删除规则',
  AreYouSureBatchDelete: '您确定要批量删除这些规则吗?',
  SearchRuleName: '搜索规则名',
  RemoveSelectedRule: '移除已选择的规则，将与当前网关解绑。网关实例通过匹配规则过滤流量。未关联网关则规则不会生效。添加规则只支持当前账号创建的规则。',
  SelectAddRule: '选择添加规则',
  GatewayRelationMore: (val: number) => `网关关联的规则数超过${val}条，请修改后重试`,
}